import { useState, useEffect, useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { AltaContext } from './AltaContext'
import { mainRequest } from 'utils/requests'

export function useVerificador(storingFN, alwaysVerify) {
  const { setCallback, setVerified } = useContext(AltaContext)
  const { formState } = useFormContext()

  useEffect(() => {
    let posible = true

    if (posible) {
      setCallback(storingFN)
      setVerified(alwaysVerify || formState.isValid)
    }
    return () => {
      posible = false
    }
  }, [setCallback, setVerified, formState.isValid, storingFN, alwaysVerify])
}

export function usePrecarga(url, property) {
  const [loading, setLoading] = useState(true)
  const { reset, trigger } = useFormContext()

  useEffect(() => {
    let posible = true

    mainRequest(url)
      .then(({ status, content }) => {
        if (posible && content.success) {
          reset(content[property])
        }
      })
      .then(() => trigger())
      .finally(() => setLoading(false))

    return () => {
      posible = false
    }
  }, [url, property, reset, trigger])

  return [loading]
}

export function useApiCall(url, setFN) {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let posible = true

    mainRequest(url)
      .then(({ content }) => {
        if (posible) {
          setFN(content)
        }
      })
      .finally(() => setLoading(false))

    return () => {
      posible = false
    }
  }, [url, setFN, setLoading])

  return [loading]
}

export function useCuit() {
  const [cuit, setCuit] = useState(0)

  useEffect(() => {
    let posible = true

    mainRequest('/ddjj/api/ingreso/cuit').then(({ status, content }) => {
      if (posible && content?.usuario?.cuit) {
        setCuit(content.usuario.cuit)
      }
    })

    return () => {
      posible = false
    }
  }, [setCuit])

  return cuit
}

export function useAppendOne(show, fields, append, item, scrollToTop = false) {
  useEffect(() => {
    if (show && fields?.length === 0) {
      append(item)
      if (scrollToTop) {
        setTimeout(() => window.scrollTo(0, 0), 200)
      }
    }
  }, [show, fields, append, item, scrollToTop])
}
